const portfolioConfig = {
  // categories : ["All", "Web design", "Applications", "Web development"],
  categories : ["All", "DevOps",  "AI", "Github"],
  projects : [
    {
      image: "github.png",
      title: 'Dashboard',
      category: 'Github',
      link: 'https://github.com/NakkaGS/Frontend-Dashboard-1',
    },
    {
      image: "github.png",
      title: 'mkbsd',
      category: 'Github',
      link: 'https://github.com/nadimkobeissi/mkbsd',
    },
    {
      image: "argocd.png",
      title: 'ArgoCD',
      category: 'DevOps',
      link: 'https://argo-cd.readthedocs.io/en/stable/',
    },
    {
      image: "storm.png",
      title: 'Co-STORM',
      category: 'AI',
      link: 'https://storm.genie.stanford.edu/',
    },
    {
      image: "render.png",
      title: 'Render',
      category: 'DevOps',
      link: 'https://render.com/',
    },
  ],
};

export default portfolioConfig;